import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFound() {
  return (
    <div className='container mt-2'>
      <Header />
      <br />
      <center>
        <h2 className='oswald'>Sorry, Page Not Found :(</h2>
      </center>
      <br />
      <hr />
      <Footer />
    </div>
  );
}
